var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projectDetails"}},[_c('Header'),_c('img',{staticClass:"img",attrs:{"src":this.$route.query.detailsSrc,"width":"60%"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }